import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { switchMap, catchError, map, withLatestFrom } from 'rxjs/operators';

import { createErrorModel, isNullOrEmpty } from '@awp/core/utils';
import { RouterNavigateAction, NoopAction } from '@awp/core/ngrx';
import { ApiInsuranceType } from '@awp/quote/models';
import * as actions from './actions';
import { CardService } from '../services';
import { SelectCardTypeFailureAction } from './actions';
import { ContentProvider } from '@awp/content';


@Injectable()
export class CardCheckEffects {

  constructor(
    private actions$: Actions<actions.Actions>,
    private cardService: CardService,
    private contentProvider: ContentProvider) { }

  @Effect()
  cardSearch$ = this.actions$.pipe(
    ofType(actions.ActionTypes.BIN_SEARCH),
    switchMap(action => {
      return this.cardService.getCards(action.payload, action.insuranceType)
        .pipe(
          map(response => {
            return response === 409 ? new actions.AlternativeBinAction() : (response == null || response.length === 0
              ? new actions.BinSearchNotFoundAction()
              : new actions.BinSearchSuccessAction(response));
          }),
          catchError(err => of(new actions.BinSearchFailureAction(createErrorModel(err))))
        );
    })
  );

  @Effect()
  cardSelected$ = this.actions$.pipe(
    ofType(actions.ActionTypes.SELECT_CARD_TYPE),
    switchMap(p =>
      this.contentProvider.get<Array<any>>('benefitTables.cardBenefits')
        .pipe(
          map(c => {
            const card = c.find(item => item.cardType === p.payload.card.cardType.code);
            return {
              selectedCard: p.payload.card,
              insuranceType: p.payload.insuranceType,
              cardContent: card
            };
          })
        )
    ),
    map(p => {
      if (p.cardContent != null) {
        if (p.insuranceType === ApiInsuranceType.TravelInsurance && !isNullOrEmpty(p.cardContent.travelInsuranceErrorCode)) {
          return new SelectCardTypeFailureAction(p.insuranceType);
        } else if (p.insuranceType === ApiInsuranceType.OtherInsurances && !isNullOrEmpty(p.cardContent.otherInsuranceErrorCode)) {
          return new SelectCardTypeFailureAction(p.insuranceType);
        }
      }

      if (p.selectedCard.cardType.code != null && p.insuranceType === ApiInsuranceType.TravelInsurance) { // Not sure why this is needing to route here
        return new RouterNavigateAction({ url: ['/', p.selectedCard.clientId, 'quote'] });
      }
      if (p.selectedCard.cardType.code == null) {
        return new SelectCardTypeFailureAction(p.insuranceType);
      }

      return new NoopAction();
    })
  );
}
